export class FilterSolicitudPersonaRenovarDocumentoModel {
    nombreEmpleado: string;
    nroDocumento: string;
    codigoSolicitud: string;
    fechaInicio?: Date;
    fechaFin?: Date;
    page: number;
    pageSize: number;
    idCompania: number;
    sedes: number[];

    constructor(){
        this.nombreEmpleado = '';
        this.nroDocumento = '';
        this.codigoSolicitud = '';
        //this.fechaInicio = new Date();
        //this.fechaFin = new Date();
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
        this.sedes = [];
    }
}